<template>
	<div class="con">
		<div class="con1 fl_r fl_j_s fl_a_c" @click="godetails()">
			<img class="con1_l" src="../../assets/47.png" />
			<div class="con1_c">绍兴零工网</div>
			<div class="con1_r">找工作 来绍兴零工网</div>
		</div>
		<div class="con2s">
			<div class="con2 fl_r fl_j_b fl_a_c">
				<div class="con2_l">
					<div class="con2_l_t fl_r fl_j_s fl_a_c">
						<div class="con2_l_t_l">{{detail.name}}</div>
						<div class="con2_l_t_r">{{detail.wages}}{{detail.wages != '面议' && detail.wages != '日结' && detail.wages != '周结' && detail.wages != '月结' && detail.wages != '不限' ? '/月':'' }}</div>
					</div>
					<div class="con2_l_c fl_r fl_j_s fl_a_c">
						<div class="con2_l_c_i" v-if="detail.gzjy">{{detail.gzjy|| ''}}</div>
						<div class="con2_l_c_i" v-if="detail.xl">{{detail.xl|| ''}}</div>
						<div class="con2_l_c_i" v-if="detail.sshy">{{detail.sshy||''}}</div>
					</div>
					<div class="con2_l_b fl_r fl_j_s fl_a_c">
						<img class="con2_l_b_l" src="../../assets/6.png" />
						<div class="con2_l_b_r">{{detail.ssgsadd}}</div>
					</div>
				</div>
				<div class="con2_r fl_r fl_j_s fl_a_c">
					<img class="con2_r_l" src="../../assets/48.jpg" />
					<div class="con2_r_r">
						<div class="con2_r_r_t">微信扫码小程序</div>
						<div class="con2_r_r_b">好机会随时聊</div>
					</div>
				</div>
			</div>
		</div>
		<div class="con3s">
			<div class="con3">
				<div class="con3_t">岗位详情</div>
				<div class="con3_bs">
					<div class="con3_bs_t">工作内容：</div>
					<div class="con3_bs_s">{{detail.note}}</div>
				</div>
				<div class="con3_bs">
					<div class="con3_bs_t">任职要求：</div>
					<div class="con3_bs_s">{{detail.remark1}}</div>
				</div>
				<div class="con3_bs">
					<div class="con3_bs_t">职位亮点：</div>
					<div class="con3_bs_s fl_r fl_j_s fl_a_c">
						<div class="con3_bs_s_i" v-for="(x,y) in detail.gwflb" :key="y">
							{{x}}
						</div>
					</div>
				</div>
				<div class="con3_b">
					<div class="con3_b_i fl_r fl_j_s fl_a_c">
						<div class="con3_b_i_l">所需人数：</div>
						<div class="con3_b_i_r">{{detail.xqrs}}人</div>
					</div>
					<div class="con3_b_i fl_r fl_j_s fl_a_c" style="padding-bottom:0px;">
						<div class="con3_b_i_l">到岗时间：</div>
						<div class="con3_b_i_r">{{detail.dgsj || '未知'}}</div>
					</div>
				</div>
				<div class="con_bn fl_r fl_j_s fl_a_c">
					<img class="con_bn_l" src="../../assets/48.jpg" />
					<div class="con_bn_r">解锁更多职位信息，请拿出手机通过微信扫一扫，海量的职位等您来！</div>
				</div>
			</div>
		</div>
		<div class="con4">
			<div class="con4_t fl_r fl_j_s fl_a_c">
				<img class="con4_t_l" src="../../assets/7.png"></u-icon>
				<div class="con4_t_r">小贴士：</div>
			</div>
			<div class="con4_i">1.本平台仅供信息发布，任何收取押金、保证金均有可能涉及诈骗，请微友务必谨慎!</div>
			<div class="con4_i">2.请告知用人单位，是在绍星招聘上看到该职位的!</div>
			<div class="con4_i">3.招聘单位做出任何损害求职者合法权益行为及违规收费，信息不实虚假信息，请<span>立即投诉</span></div>
		</div>
		<div style="width:100%;height:50px;"></div>
	</div>
</template>
<script>
	import axios from "axios";
	import footers from '@/components/footers.vue'
	export default {
		name: 'Detail',
		components: {
			footers,
		},
		data () {
			return {
				detail: {},
				details: {},
				id: ''
			}
		},
		mounted () {
			this.id = this.$route.query.id
			this.getdetail()
		},
		methods: {
			godetails () {
				this.$router.push({ path: './' })
			},
			async getdetail () {
				let params = {
					id: this.id
				}
				const _this = this
				axios.get("https://xcx.sxlgw.cn:891/system/pinfo/getDetail", { params: params }).then(function (res) {
					if (res.data.obj.pi.gwfl != null) {
						let arr = res.data.obj.pi.gwfl.split(',')
						res.data.obj.pi.gwflb = arr
					}
					_this.detail = res.data.obj.pi
					_this.details = res.data.obj.ci
				}).catch(function (error) {})
			},
		},
	}
</script>
<style lang="less" scoped>
	.con_bn {
		width: 1620px;
		margin: 0 auto;
		// margin-top: 30px;
		margin-bottom: 30px;

		.con_bn_l {
			width: 175px;
			height: 175px;
			display: block;
			margin-right: 70px;
		}

		.con_bn_r {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 28px;
			color: #229871;
			line-height: 28px;
		}
	}

	.con2s {
		width: 100%;
		height: 301px;
		background: #FFFFFF;
		overflow: hidden;

		.con2 {
			width: 1240px;
			margin: 0 auto;
			margin-top: 55px;

			.con2_l {
				.con2_l_t {
					.con2_l_t_l {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 500;
						font-size: 46px;
						color: #000000;
						line-height: 46px;
					}

					.con2_l_t_r {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 500;
						font-size: 46px;
						color: #33CC99;
						line-height: 46px;
						margin-left: 50px;
					}
				}

				.con2_l_c {
					padding-top: 30px;

					.con2_l_c_i {
						padding: 11px 33px;
						background: #F5F4F4;
						border-radius: 6px 6px 6px 6px;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 18px;
						color: #666666;
						line-height: 18px;
						text-align: center;
						margin-right: 15px;
					}
				}

				.con2_l_b {
					padding-top: 30px;

					.con2_l_b_l {
						width: 30px;
						height: 30px;
						display: block;
						margin-right: 2px;
					}

					.con2_l_b_r {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 400;
						font-size: 18px;
						color: #666666;
						line-height: 18px;
						text-align: left;
					}
				}
			}

			.con2_r {
				.con2_r_l {
					width: 100px;
					height: 100px;
					display: block;
				}

				.con2_r_r {
					margin-left: 30px;

					.con2_r_r_t {
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: bold;
						font-size: 24px;
						color: #000000;
						line-height: 25px;
						text-align: center;
					}

					.con2_r_r_b {
						width: 100%;
						font-family: Source Han Sans CN, Source Han Sans CN;
						font-weight: 500;
						font-size: 18px;
						color: #B5B9B6;
						line-height: 18px;
						letter-spacing: 8px;
						text-align: center;
						padding-top: 15px;
					}
				}
			}
		}
	}

	.con4 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 30px;
		background-color: #fff;
		padding-bottom: 30px;

		// height: 224px;
		.con4_t {
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 30px;
			padding-top: 30px;

			.con4_t_l {
				width: 30px;
				height: 30px;
				display: block;
			}

			.con4_t_r {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: bold;
				font-size: 24px;
				color: #FF8A3A;
				line-height: 24px;
				text-align: left;
				padding-left: 10px;
			}
		}

		.con4_i {
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 10px;
			color: #888787;
			font-size: 18px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 400;
			color: #888787;
			line-height: 18px;
			text-align: left;

			span {
				color: #FF8A3A;
			}
		}
	}

	.con3s {
		width: 1240px;
		margin: 0 auto;
		margin-top: 30px;
		background: #fff;
		border-radius: 16px 16px 16px 16px;
	}

	.con3 {
		width: 1200px;
		margin: 0 auto;
		border-radius: 16px;
		margin-bottom: 30px;
		overflow: hidden;
		background-color: #fff;
		margin-top: 30px;

		.con3_t {
			width: 1200px;
			margin: 0 auto;
			padding-top: 30px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 32px;
			color: #353535;
			line-height: 32px;
			text-align: left;
		}

		.con3_b {
			width: 1200px;
			margin: 0 auto;
			margin-top: 30px;
			margin-bottom: 20px;

			.con3_b_i {
				padding-bottom: 20px;

				.con3_b_i_l {
					font-weight: 500;
					font-size: 24px;
					color: #353535;
				}

				.con3_b_i_r {
					font-size: 24px;
					color: #333;
				}

				.con3_b_i_rs {
					font-size: 24px;
					color: #fa3534;
				}
			}
		}

		.con3_bs {
			width: 1200px;
			margin: 0 auto;
			margin-top: 30px;
			margin-bottom: 30px;

			.con3_bs_t {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 500;
				font-size: 28px;
				color: #353535;
				line-height: 28px;
				text-align: left;
				// padding-top: 20px;
			}

			.con3_bs_s {
				font-family: Source Han Sans CN, Source Han Sans CN;
				width: 1200px;
				margin: 0 auto;
				margin-top: 15px;
				font-size: 24px;
				color: #4E4E4E;
				flex-wrap: wrap;
				text-align: left;

				.con3_bs_s_i {
					margin-right: 20px;
					padding: 6px 18px;
					background: #EEEEEE;
					border-radius: 6px 6px 6px 6px;
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 400;
					font-size: 15px;
					color: #666666;
					text-align: center;
				}
			}
		}
	}

	.con {
		width: 100%;
		background: url('../../assets/43.png') no-repeat;
		background-size: 100%;
		background-color: #F5FCF9;
	}

	.con1 {
		width: 100%;
		height: 81px;
		background: #111111;

		.con1_l {
			width: 38px;
			height: 38px;
			display: block;
			margin-left: 58px;
		}

		.con1_c {
			font-family: Inter, Inter;
			font-size: 32px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 9px;
		}

		.con1_r {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 7px;
			padding-top: 10px;
		}
	}
</style>